import { useEffect, useState } from "react";
import { Sparkles, Clock } from "lucide-react";
import { api } from "../lib/api";

/**
 * Slim public promo strip for the "Become a handyman" signup flow.
 * Renders only while the launch-week $200 credit window is active.
 */
export function PromoBanner() {
  const [promo, setPromo] = useState(null);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    let alive = true;
    api.get("/promo/handyman")
      .then((r) => { if (alive) setPromo(r.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    if (!promo?.active) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [promo]);

  if (!promo?.active) return null;
  const end = new Date(promo.ends_at).getTime();
  const diff = end - now;
  if (Number.isNaN(end) || diff <= 0) return null;

  const days = Math.floor(diff / (24 * 60 * 60 * 1000));
  const hours = Math.floor((diff / (60 * 60 * 1000)) % 24);
  const mins = Math.floor((diff / (60 * 1000)) % 60);

  return (
    <div
      data-testid="public-promo-banner"
      className="w-full max-w-lg mb-4 rounded-2xl border border-terracotta/40 bg-gradient-to-r from-terracotta/15 via-terracotta/8 to-cognac/10 px-4 py-3 flex items-center gap-3 animate-fade-up"
    >
      <div className="w-9 h-9 rounded-full bg-terracotta/20 text-terracotta flex items-center justify-center shrink-0">
        <Sparkles className="w-4 h-4" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-display text-base text-charcoal leading-tight" data-testid="public-promo-headline">
          Launch promo — year 1 is on us
        </p>
        <p className="text-xs text-charcoal/70 mt-0.5 flex items-center gap-1.5">
          <Clock className="w-3 h-3 text-terracotta" />
          <span data-testid="public-promo-countdown">
            Ends in {days}d {String(hours).padStart(2, "0")}h {String(mins).padStart(2, "0")}m
          </span>
          <span className="text-charcoal/40">·</span>
          <span className="text-charcoal/60">
            <span className="line-through mr-1">${Math.round(promo.full_price)}</span>
            <span className="text-terracotta font-semibold">FREE</span> year 1
          </span>
        </p>
      </div>
    </div>
  );
}
